import React from "react";
import UserMain from 'components/users/list/main'
import UserCreate from "components/users/details/create";
import UserDetails from "components/users/details/details";
import UserEdit from 'components/users/details/edit'
import Errors from 'components/error404';


export function UserRoutes(){
    return [
        {
            path: '',
            element: (<UserMain />),
            errorElement: <Errors />,
        },
        {
            path: 'list',
            element: (<UserMain />),
            errorElement: <Errors />,
        },
        {
            path: 'create',
            element: (<UserCreate />),
            errorElement: <Errors />,
        },
        {
            path: 'details/:userId',
            element: (<UserDetails />),
            errorElement: <Errors />
        },
        {
            path: 'edit/:userId',
            element: (<UserEdit />),
            errorElement: <Errors />
        }
    ]    
}

export default UserRoutes;